import { getMaxStringSchema, getSelectSchema, getStringSchema } from 'src/compass/shared/schemas';
import * as Yup from 'yup';

export const CommissionSchema = Yup.object().shape({
  closedThruDate: Yup.date().required('Date is required'),
  lrpPayrollExportCode: getStringSchema(50, 'LRP Default Payroll Export Code'),
  sharepointSiteId: getSelectSchema('Sharepoint Site'),
  sharepointRoot: getStringSchema(255, 'Sharepoint Root'),
  prelimEmailTemplate: getMaxStringSchema().required("Prelim Email Template is required."),
  cmePayrollExportCode_1099: getStringSchema(50, 'CME Payroll Export Code (1099)'),
  cmePayrollExportCode_Employee: getStringSchema(50, 'CME Payroll Export Code (Employee)'),
  lrpPayrollExportCode_1099: getStringSchema(50, 'LRP Payroll Export Code (1099)'),
  lrpPayrollExportCode_Employee: getStringSchema(50, 'LRP Payroll Export Code (Employee)'),
});
